import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../shared/api/types'

function errorStatus(error: unknown) {
  if (error instanceof ApiError) return error.status
  if (typeof error === 'object' && error && 'status' in error) return Number(error.status)
  return Number.NaN
}

export function shouldRetryQuery(failureCount: number, error: unknown) {
  if (failureCount >= 2) return false
  const status = errorStatus(error)
  return status === 0 || status === 408 || status === 425 || status === 429 || status >= 500
}

export function queryRetryDelay(attemptIndex: number) {
  return Math.min(300 * 2 ** attemptIndex, 1_500)
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: shouldRetryQuery,
      retryDelay: queryRetryDelay,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
})
